export default __webpack_public_path__ + "locales/si/EmbeddingPanel.json?hash=869ccd1b496c7a122a487592fe732e1e";